import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { ISearchAuditLogsFilter, ISearchAuditLogsResult, IAuditLogMetadata } from '../../entities/SystemAuditLog/SystemAuditLog';

export class SystemAuditLogApi extends BaseApi {
  private static readonly apiUrls = {
    search: '/Audit/search',
    metadata: '/Audit/metadata',
  };

  constructor() {
    super('/Audit');
  }

  /**
   * Search audit logs with flexible filtering and pagination
   */
  async searchAuditLogs(filter: ISearchAuditLogsFilter): Promise<ISearchAuditLogsResult> {
    try {
      const response = await (SystemAuditLogApi as any).sendApiRequest<ISearchAuditLogsResult>({
        method: HttpMethodEnum.POST,
        path: SystemAuditLogApi.apiUrls.search,
        data: filter
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  /**
   * Get metadata for audit log filters (distinct values)
   */
  async getAuditLogMetadata(): Promise<IAuditLogMetadata> {
    return (SystemAuditLogApi as any).sendApiRequest<IAuditLogMetadata>({
      method: HttpMethodEnum.GET,
      path: SystemAuditLogApi.apiUrls.metadata
    });
  }
}

export const systemAuditLogApi = new SystemAuditLogApi();
